import { API_CONFIG } from "../config/api.config";

const parseResponse = async (response) => {
  const text = await response.text();
  let data = null;
  try {
    data = text ? JSON.parse(text) : null;
  } catch {
    data = { message: text };
  }
  if (!response.ok) {
    throw new Error(data?.error || "Request failed.");
  }
  return data;
};

const authHeaders = (accessToken) => ({
  Accept: "application/json",
  Authorization: `Bearer ${String(accessToken || "").trim()}`,
});

export async function fetchClientzoneContract(contractId, accessToken) {
  const token = String(accessToken || "").trim();
  const id = Number(contractId);
  if (!token || !Number.isFinite(id) || id < 1) {
    throw new Error("Invalid contract request.");
  }

  const response = await fetch(`${API_CONFIG.baseUrl}/public/clientzone/contracts/${id}`, {
    method: "GET",
    headers: authHeaders(token),
  });
  return parseResponse(response);
}

export async function fetchClientzoneContacts(accessToken) {
  const token = String(accessToken || "").trim();
  if (!token) {
    throw new Error("Session expired. Please sign in again.");
  }

  const response = await fetch(`${API_CONFIG.baseUrl}/public/clientzone/contacts`, {
    method: "GET",
    headers: authHeaders(token),
  });
  const data = await parseResponse(response);
  return Array.isArray(data?.contacts) ? data.contacts : [];
}

export async function fetchClientzoneContact(contactId, accessToken) {
  const token = String(accessToken || "").trim();
  const id = Number(contactId);
  if (!token || !Number.isFinite(id) || id < 1) {
    throw new Error("Invalid contact request.");
  }

  const response = await fetch(`${API_CONFIG.baseUrl}/public/clientzone/contacts/${id}`, {
    method: "GET",
    headers: authHeaders(token),
  });
  const data = await parseResponse(response);
  return data?.contact || null;
}

export async function createClientzoneContact(payload, accessToken) {
  const token = String(accessToken || "").trim();
  if (!token) {
    throw new Error("Session expired. Please sign in again.");
  }

  const response = await fetch(`${API_CONFIG.baseUrl}/public/clientzone/contacts`, {
    method: "POST",
    headers: {
      ...authHeaders(token),
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload || {}),
  });
  const data = await parseResponse(response);
  return data?.contact || null;
}

export async function updateClientzoneContact(contactId, payload, accessToken) {
  const token = String(accessToken || "").trim();
  const id = Number(contactId);
  if (!token || !Number.isFinite(id) || id < 1) {
    throw new Error("Invalid contact request.");
  }

  const response = await fetch(`${API_CONFIG.baseUrl}/public/clientzone/contacts/${id}`, {
    method: "PUT",
    headers: {
      ...authHeaders(token),
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload || {}),
  });
  const data = await parseResponse(response);
  return data?.contact || null;
}

export async function fetchClientzoneTickets(accessToken) {
  const token = String(accessToken || "").trim();
  if (!token) {
    throw new Error("Session expired. Please sign in again.");
  }

  const response = await fetch(`${API_CONFIG.baseUrl}/public/clientzone/tickets`, {
    method: "GET",
    headers: authHeaders(token),
  });
  const data = await parseResponse(response);
  return Array.isArray(data?.tickets) ? data.tickets : [];
}

export async function fetchClientzoneTicket(ticketId, accessToken) {
  const token = String(accessToken || "").trim();
  const id = Number(ticketId);
  if (!token || !Number.isFinite(id) || id < 1) {
    throw new Error("Invalid ticket request.");
  }

  const response = await fetch(`${API_CONFIG.baseUrl}/public/clientzone/tickets/${id}`, {
    method: "GET",
    headers: authHeaders(token),
  });
  return parseResponse(response);
}

export async function createClientzoneTicket(payload, accessToken) {
  const token = String(accessToken || "").trim();
  if (!token) {
    throw new Error("Session expired. Please sign in again.");
  }

  const response = await fetch(`${API_CONFIG.baseUrl}/public/clientzone/tickets`, {
    method: "POST",
    headers: {
      ...authHeaders(token),
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload || {}),
  });
  return parseResponse(response);
}

export async function replyClientzoneTicket(ticketId, payload, accessToken) {
  const token = String(accessToken || "").trim();
  const id = Number(ticketId);
  if (!token || !Number.isFinite(id) || id < 1) {
    throw new Error("Invalid ticket request.");
  }

  const response = await fetch(`${API_CONFIG.baseUrl}/public/clientzone/tickets/${id}/messages`, {
    method: "POST",
    headers: {
      ...authHeaders(token),
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload || {}),
  });
  return parseResponse(response);
}
